import {handleActions} from 'redux-actions';
import {format} from 'date-fns';
import {curry} from 'ramda';

import {
    INGEST_REPORT_SET,
    INGEST_REPORT_RESET,
} from './IngestReportActions';
import {
    IngestReport,
    IngestReportReduced,
    ValidationReportItem,
} from '../IngestReportTypes';

export const getOverallResult = (acc: any, {result}:any) => {
    switch(result) {
    case 'PASSED':
        return {
            ...acc,
            passedCount: ++acc.passedCount,
        };
    case 'FAILED':
        return {
            ...acc,
            errorCount: ++acc.errorCount,
        };
    case 'WARNING':
        return {
            ...acc,
            warningCount: ++acc.warningCount,
        };
    
    default:
        return acc;
    }
};

const filterItem = curry((type, item) => {
    return item.result === type;
});

const getResultsOf = curry((type, validations) => {
    return validations.filter(filterItem(type));
});

const getFailedReports = getResultsOf('FAILED');
const getWarningReports = getResultsOf('WARNING');
const getPassedReports = getResultsOf('PASSED');
const getUnknownReports = getResultsOf('N/A');

export const sortByResult = (validations: ValidationReportItem[]) => {
    return [
        ...getFailedReports(validations),
        ...getWarningReports(validations),
        ...getPassedReports(validations),
        ...getUnknownReports(validations),
    ];
};

const getTitle = (payload: IngestReport) => {
    const {
        title,
        seriesTitle,
        seasonNumber,
        number,
    } = payload;
    
    if (payload.type === 'season')
        return `${title} S${number}`;
    
    if (payload.type === 'episode')
        return `${seriesTitle} S${seasonNumber} E${number}`;
    
    return payload.title;
};

export const formatItem = (payload: IngestReport) => {
    const initialSummary = {
        passedCount: 0,
        warningCount: 0,
        errorCount: 0,
    };
    const {
        validationReportItems: validations,
        updatedAt,
    } = payload;
    const updated = new Date(updatedAt);
    
    const summary = validations.reduce(
        getOverallResult,
        initialSummary,
    );
    
    const title = getTitle(payload);
    
    return {
        ...payload,
        ...summary,
        title,
        validationReportItems: sortByResult(validations),
        date: format(updated, 'Ppp'),
    };
};

export const setIngestItem = (state: any, {payload}: any): IngestReportReduced | null => {
    if (payload && !payload.isAxiosError)
        return formatItem(payload);
    
    return null;
};

export const resetIngestItem = () => {
    return initialState;
};

const initialState = null;

const handlers = {
    [INGEST_REPORT_SET]: setIngestItem,
    [INGEST_REPORT_RESET]: resetIngestItem,
};

export default handleActions(handlers, initialState);
